import { z } from "zod";
import { ZDateish } from "./commonSchema.js";
import { ZObjectIdString } from "./accessControlSchema.js";

export const ZReactionUser = z.object({
  _id: ZObjectIdString,
  name: z.string(),
});

export const ZReaction = z.object({
  user: ZReactionUser,
  date: ZDateish,
  emoji: z.string(),
});

export type IReaction = z.infer<typeof ZReaction>;
